import { render, staticRenderFns } from "./SosView.vue?vue&type=template&id=3b5b4e60&"
import script from "./SosView.vue?vue&type=script&lang=js&"
export * from "./SosView.vue?vue&type=script&lang=js&"
import style0 from "./SosView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports